var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 36 36",
    height: 80,
    viewBox: "0 0 36 36",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.904 20.355c-3.782-5.791-3.38-11.727-5.203-14.518s-7.256-7.603-20.093.782-9.572 17.5-7.566 20.569c9.388 14.372 39.561 3.423 32.862-6.833z",
    fill: "#efefef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m29.25 18.75v6.5c0 1.1-.9 2-2 2h-18.5c-1.1 0-2-.9-2-2v-6.5h3.76c.44 0 .83.29.95.71l1.08 3.58c.12.42.51.71.95.71h9.02c.44 0 .83-.29.95-.71l1.08-3.58c.12-.42.51-.71.95-.71z",
    fill: "#"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.25 18.75h-3.76c-.44 0-.83.29-.95.71l-1.08 3.58c-.12.42-.51.71-.95.71h-9.02c-.44 0-.83-.29-.95-.71l-1.08-3.58c-.12-.42-.51-.71-.95-.71h-3.76l4.5-10h13.5z",
    fill: "#FF781F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.71 23.04 1.08-3.58c.12-.42.51-.71.95-.71h-2.25c-.44 0-.83.29-.95.71l-1.08 3.58c-.12.42-.51.71-.95.71h2.25c.44 0 .83-.29.95-.71z",
    fill: "#d5dbe1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9 25.25v-6.5h-2.25v6.5c0 1.1.9 2 2 2h2.25c-1.1 0-2-.9-2-2z",
    fill: "#d5dbe1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m11.25 8.75-4.5 10h2.25l4.5-10z",
    fill: "#F05237"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m14.79 23.04-1.08-3.58c-.12-.42-.51-.71-.95-.71h-2.25c.44 0 .83.29.95.71l1.08 3.58c.12.42.51.71.95.71h2.25c-.44 0-.83-.29-.95-.71z",
    fill: "#F05237"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a4afc1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.744 6.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2c-.276 0-.5.225-.5.5s.224.5.5.5.5-.225.5-.5-.224-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.605 4.173h1v2h-1z",
    transform: "matrix(.707 -.707 .707 .707 -1.284 7.246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.927 8.739h2v1h-2z",
    transform: "matrix(.707 -.707 .707 .707 -4.211 8.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.994 4.673h2v1h-2z",
    transform: "matrix(.707 -.707 .707 .707 -.145 9.996)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m27.25 28h-18.5c-1.517 0-2.75-1.233-2.75-2.75v-6.5c0-.106.022-.211.066-.308l4.5-10c.121-.269.389-.442.684-.442h13.5c.295 0 .563.173.684.442l4.5 10c.044.097.066.202.066.308v6.5c0 1.517-1.233 2.75-2.75 2.75zm-19.75-9.089v6.339c0 .689.561 1.25 1.25 1.25h18.5c.689 0 1.25-.561 1.25-1.25v-6.339l-4.235-9.411h-12.53z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m22.506 24.5h-9.012c-.778 0-1.452-.501-1.676-1.247l-1.073-3.574c-.032-.105-.13-.179-.239-.179h-3.756v-1.5h3.756c.778 0 1.452.501 1.676 1.247l1.073 3.574c.032.106.13.179.239.179h9.012c.109 0 .208-.073.239-.179l1.073-3.574c.224-.746.897-1.247 1.676-1.247h3.756v1.5h-3.756c-.109 0-.208.073-.239.179l-1.073 3.574c-.224.746-.898 1.247-1.676 1.247z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m2 26.5h32v1.5h-32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.a16b71e3bf9dad82105728848ff80e8e.svg";
export { ForwardRef as ReactComponent };